import { Box, Icon, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';

import AuthService from './shared/services/AuthService';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Unstable_Grid2';
import NotificationsIcon from '@mui/icons-material/Notifications';
import toastStyles from './AppToast.module.css';
import useStatus from './shared/hooks/useStatus';
import useThemes from './shared/hooks/useThemes';

export interface IAppToastProps {
  /** Message (plain text) to display in toast. */
  message: string;
}

/** Key to store toast dismissed in LocalStorage. */
const LOCALSTORAGE_KEY = 'dismissToast-{userkey}';

/**
 * Component to display a toast message, cancelable by the user.
 */
const AppToast = () => {
  const { appToast } = useStatus();
  const { muiTheme } = useThemes();
  const [localStorageKey, setLocalStorageKey] = useState<string>();
  const [hideToast, setHideToast] = useState(false);

  useEffect(() => {
    setLocalStorageKey(
      LOCALSTORAGE_KEY.replace('{userkey}', `${AuthService.Userkey}`)
    );
  }, [AuthService.Userkey]);

  useEffect(() => {
    if (!appToast) {
      localStorage.removeItem(localStorageKey);
    }
    setHideToast(
      !appToast || localStorage.getItem(localStorageKey) === appToast
    );
  }, [appToast, localStorageKey]);

  const onClose = () => {
    localStorage.setItem(localStorageKey, appToast);
    setHideToast(true);
  };

  return hideToast ? (
    <></>
  ) : (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        color: muiTheme.palette.secondary.contrastText,
        bgcolor: muiTheme.palette.primary.main
      }}
      className={`${toastStyles.banner}`}
    >
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={toastStyles.content}
      >
        <Icon fontSize="medium" className={toastStyles.icon}>
          <NotificationsIcon />
        </Icon>
        <Box className={toastStyles.message}>{appToast}</Box>
        <IconButton
          className={toastStyles.close}
          onClick={onClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default AppToast;
